import React, { useState, useContext } from 'react';
import { View } from 'react-native';
import Commissions from './Commissions';
import Salespeople from './Salespeople';
import styled from 'styled-components/native';
import {
  ContentContainer,
  LinkContainer,
  LinkSpace,
  MainContainer,
  TableContainer,
  PageTitle,
  TabButtonContainer,
  TabButton,
  TabText
} from '../elements';
import { elRed, elLightGray } from '../styles/colors';
import AuthContext from '../contexts/AuthContext';

const CommissionsAndSalespeopleContainer = styled(View)`
  display: flex;
  flex-direction: row;

`;

const CommissionsContainer = styled(View)`
  flex: 1;
`;

const SalespeopleContainer = styled(View)`
  flex: 1;
`;

const CommissionsAndSalespeople = () => {
  const [activeTab, setActiveTab] = useState('Commissions');
  const { user } = useContext(AuthContext);
  if(!user || (user && !user.canAccessCommissions)) return false;
  return (
    <MainContainer>
      <ContentContainer>
        <PageTitle>Commissions and Salespeople</PageTitle>
        <TabButtonContainer>
          <TabButton
            onPress={() => setActiveTab('Commissions')}
            style={{backgroundColor: activeTab === 'Commissions' ? elRed : elLightGray}}
          >
            <TabText>Commissions</TabText>
          </TabButton>
          <TabButton
            onPress={() => setActiveTab('Salespeople')}
            style={{backgroundColor: activeTab === 'Salespeople' ? elRed : elLightGray}}
          >
            <TabText>SalesPeople</TabText>
          </TabButton>
        </TabButtonContainer>
        <CommissionsAndSalespeopleContainer>
          {activeTab === 'Commissions' ?
            <CommissionsContainer>
              <Commissions />
            </CommissionsContainer> :
            <SalespeopleContainer>
              <Salespeople />
            </SalespeopleContainer>
          }
        </CommissionsAndSalespeopleContainer>
      </ContentContainer>
    </MainContainer>
  )
}

export default CommissionsAndSalespeople;